const HoneypotInput = ({ onBotDetected }) => {
  return (
    <input
      type="text"
      tabIndex="-1"
      name="website"
      autoComplete="off"
      className="website"
      onChange={onBotDetected.bind(null, true)}
    />
  );
};

export default HoneypotInput;
